export enum ActivityShareType {
    None = '',
    Customer = 'Customer',
    Field = 'Field',
    Tenant = 'Tenant',
    NotShared = 'Not Shared'
}

export enum ActivitySource {
    Id = 'id',
    Tenant = 'tenant',
    Compliance = 'compliance',
    ClientPortal = 'clients',
    ContractorPortal = 'contractors',
    Mobile = 'mobile',
    Connect = 'connect'
}

export interface Shareable {
    systemSharing?: boolean;
    shared?: ActivityShareType[];
    sensitive?: boolean;
    // The name i want to name it is instances but in the task implement this interface already have instances field.
    referenceInstances?: number;
}

export const sharableEquals = (a: Shareable, b: Shareable): boolean => {

    const aSystemSharing = a?.systemSharing;
    const bSystemSharing = b?.systemSharing;

    const aCustomer = a?.shared?.includes(ActivityShareType.Customer);
    const bCustomer = b?.shared?.includes(ActivityShareType.Customer);

    const aField = a?.shared?.includes(ActivityShareType.Field);
    const bField = b?.shared?.includes(ActivityShareType.Field);

    const aSensitive = a?.sensitive;
    const bSensitive = b?.sensitive;

    const systemSharing = aSystemSharing === bSystemSharing;
    const customer = aCustomer === bCustomer;
    const filed = aField === bField;
    const sensitive = aSensitive === bSensitive;

    const equal = systemSharing && customer && filed && sensitive;

    console.log('sharableEquals', equal, a, b);

    return equal;
}

export const notShared = () => {
    return {
        systemSharing: true,
        shared: [],
        sensitive: false
    }
}
